import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {of} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {TechnicalDeviceElementApiService} from '@api/technical-device-element.api.service';
import {Conclusion} from '@namespaces/conclusion.namespace';
import {RoutesStorage} from '@helpers/routes.helper';

/**
 * Создание нового шаблонного заключения и резолв его
 */
@Injectable()
export class ConclusionBlankResolver implements Resolve<any> {
    protected redirectUrl = RoutesStorage.WorkingObject.list;

    constructor(
        private service: TechnicalDeviceElementApiService,
        private router: Router,
    ) {}

    resolve(snapshot: ActivatedRouteSnapshot) {

        const { technicalCardId, elementId } = snapshot.parent.params;

        return this.service.post({
            url: this.service.getConclusionBlankPath(elementId),
            dataBody: {
                technical_card_id: technicalCardId,
            }
        })
            .pipe(
                take(1),
                map((data: Conclusion.FormData) => {
                    if (data) {
                        this.router.navigate([RoutesStorage.Conclusion.edit(data.id, elementId, technicalCardId)]);
                        return data;
                    } else {
                        return this.processNullData();
                    }
                }),
                catchError(() => {
                    return of(this.processError());
                }),
            );
    }

    processNullData(): any {
        this.redirect();
        return null;
    }

    processError() {
        this.redirect();
        return null;
    }

    protected redirect() {
        this.router.navigate(this.redirectUrl ? [this.redirectUrl] : ['/']);
    }
}
